import type { Ref } from "react";
import type { AvatarSize } from "@design-system/Avatar/Avatar";
import {
    EntityAvatarImage,
    type EntityAvatarImageEntity,
} from "@design-system/Avatar/EntityAvatarImage";
import { AvatarCopyId } from "./AvatarCopyId";

export type EntityAvatarEntity = EntityAvatarImageEntity;

export interface EntityAvatarProps {
    entity: EntityAvatarEntity;
    size?: AvatarSize;
    /** The entity's database ID, copied on right-click when `showDbIds` is on. */
    copyId?: number;
    className?: string;
    /** Set when the entity's name is visible next to the avatar. */
    "aria-hidden"?: boolean;
    ref?: Ref<HTMLSpanElement>;
}

/**
 * An entity's logo as a square, else the initial of its name on its
 * `iconColor`. Personal entities are always gray.
 */
export const EntityAvatar = ({
    copyId,
    ...imageProps
}: Readonly<EntityAvatarProps>) => {
    const avatar = <EntityAvatarImage {...imageProps} />;

    return copyId === undefined ? (
        avatar
    ) : (
        <AvatarCopyId id={copyId} label="Entity">
            {avatar}
        </AvatarCopyId>
    );
};
